import { useState, useEffect } from 'react';

const CounterWithText = ({ counter, type, title }) => {
  const [count, setCount] = useState(0);
  const isNumeric = !isNaN(counter) && !isNaN(parseFloat(counter));

  const duration = 2000;

  useEffect(() => {
    if (!isNumeric) return; // If not numeric, skip animation

    const targetCount = parseFloat(counter);
    let start = 0;
    const increment = targetCount / (duration / 16);

    const timer = setInterval(() => {
      start += increment;
      if (start >= targetCount) {
        setCount(targetCount);
        clearInterval(timer);
      } else {
        setCount(Math.ceil(start));
      }
    }, 16);

    return () => clearInterval(timer);
  }, [counter]);

  return (
    <div style={{ textAlign: 'center', marginTop: '20px' }}>
      <div className="numberlarge">
        {isNumeric ? count : counter}
        {type}
      </div>
      <div  className='number-usp-small'>{title}</div>
    </div>
  );
};

export default CounterWithText;
